import { forwardRef } from "react";
import cx from "classnames";

import styles from "./Icon.module.scss";

import * as icons from "./Icons";

export type IconVariants =
  "closeMajor"
  | "closeMinor"
  | "backMajor"
  | "menuMajor"
  | "alertMajor"
  | "alertMinor"
  | "dropdownMinor"
  | "dropdownMajor"
  | "chevronLeftMajor"
  | "chevronRightMajor"
  | "moreActionsMinor"
  | "chevronLeftMinor"
  | "chevronRightMinor"
  | "arrowUpRight"
  | "searchMajor"
  | "infoMajor"
  | "chevronDown"
  | "chevronUp"
  | "moreVertical"
  | "trash"
  | "add"
  | "currencyDollar"
  | "clipboardDocument"
  | "check"
  | "userCheck"
  | "userCancel"
  | "buildings"
  | "shoppingCart"
  | "userGroup"
  | "lock"
  | "sendEmail"
  | "arrow"
  | "history"
  | "paperclip"
  | "squares"
  | "pencil"
  | "share"
  | "eye"
  | "archive"
  | "restart"
  | "sandwichMenu"
  | "logo"
  | "image"
  | "document"
  | "upload"
  | "exclamation"
  | "ownspaceCheck"
  | "shieldPerson"
  | "visible"
  | "notVisible"
  | "moreInfo"
  | "chatBubble"
  | "rightArrow"
  | "envelope"
  | "phone"
  | "calendar"
  | "idCard"
  | "paymentCard"
  | "ticket"
  | "download"
  | "qrCode"
  | "minus"
  | "ruler"
  | "bill"
  | "clockThree"
  | "bolt"
  | "tv"

interface Props {
  icon: IconVariants,
  onClick?: (e?: React.MouseEvent) => void,
  ariaLabel?: string,
  className?: string,
  disabled?: boolean
}

export const Icon = forwardRef<HTMLSpanElement, Props>(({
  icon,
  onClick,
  ariaLabel,
  className,
  disabled
}, ref) => {
  return (
    <span
      ref={ref}
      className={cx(styles.Icon, className, {
        [styles.pointer]: onClick,
        [styles.disabled]: disabled
      })}
      onClick={disabled ? undefined : onClick}
      aria-label={ariaLabel}
    >
      {/* eslint-disable-next-line import/namespace */}
      {icons[icon]}
    </span>
  )
});

Icon.displayName = "Icon";

